export default __webpack_public_path__ + "static/media/muebles.f89a8036.jpeg";